import React from 'react'
import { object, bool, string } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'

const campaignDescriptionCss = css`
  h4 {
    font-size: 1.75rem;
    line-height: 2.25rem;
    margin-top: 0px;
    margin-bottom: 12px;

    ${mediaQueries.xsmallScreen(200)} {
      white-space: pre-line;
      margin-top: 16px;
      font-size: 2rem;
      line-height: 2.5rem;
    }
  }

  h5 {
    line-height: 30px;
    margin-top: 16px;
    margin-bottom: 10px;
    font-size: 24px;
  }

  > small {
    display: block;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 24px;
  }
`

const AppDescription = ({ campaign, isMainCampaign, displayAppName }) => {
  if (!campaign?.description) {
    return null
  }

  const appName = campaign?.applications?.[0]?.name

  return (
    <div
      css={campaignDescriptionCss}
      className={`description-${campaign.id}`}
      data-test={'campaign-description-wrapper'}
    >
      {isMainCampaign ? (
        <h1>{displayAppName ? appName : campaign.name}</h1>
      ) : (
        <h2>{displayAppName ? appName : campaign.name}</h2>
      )}
      {campaign.description.trim() && <p>{campaign.description}</p>}
    </div>
  )
}

AppDescription.propTypes = {
  campaign: object,
  isMainCampaign: bool,
  displayAppName: bool,
  sizing: string,
}

export default AppDescription
